import { useCreateDataTableOptions } from "@/components/data-table/hooks/useCreateDataTableOptions";
import { useDynamicQueryParams } from "@/hooks/useDynamicQueryParams";
import { Filters, mergeFilters } from "@/lib/filters";
import { FetchListRequest } from "@/services/api";
import { DefaultStoreProjectAssigneesService } from "@/services/defaultStoreProjectAssignees";
import { DefaultStoreProjectAssigneeListItem } from "@/types/defaultStoreProjectAssignee";
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const useDefaultStoreProjectAssigneeListQuery = ({
  enabled = true,
  filters: filtersFromProps,
}: {
  enabled?: boolean;
  filters?: Filters<DefaultStoreProjectAssigneeListItem>;
} = {}) => {
  const name = "defaultStoreProjectAssignees";
  const options =
    useCreateDataTableOptions<DefaultStoreProjectAssigneeListItem>(name);
  const fetchList = (
    fetchParams: FetchListRequest<DefaultStoreProjectAssigneeListItem>,
  ) => {
    return DefaultStoreProjectAssigneesService.getList(fetchParams);
  };

  const filters = useMemo(
    () => mergeFilters(options.filters, filtersFromProps),
    [filtersFromProps, options.filters],
  );

  const queryKey = useDynamicQueryParams(name, options);
  const query = useInfiniteQuery({
    queryKey,
    queryFn: ({ pageParam }) =>
      fetchList({
        lastItem: pageParam,
        filters,
        sorting: options.sorting[0],
      }),
    initialPageParam: undefined,
    getNextPageParam: ({ last_item }) => last_item,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    enabled,
  });

  return {
    query,
    options,
  };
};
